import { render, staticRenderFns } from "./AnalysisItem.vue?vue&type=template&id=14a63068&scoped=true&"
import script from "./AnalysisItem.vue?vue&type=script&lang=js&"
export * from "./AnalysisItem.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisItem.vue?vue&type=style&index=0&id=14a63068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a63068",
  null
  
)

export default component.exports